import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

class CONTRACT_LAST_EDP extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [!this.props.inputParam_UseFake ? ((this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item !== null) ? this.props.inputParam_ComponentContent.item.goalPercent.toFixed(2) : 0) : 50],
      options: {
        chart: {
          type: 'radialBar',
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
            radialBar: {
                track: {
                    background: "#e7e7e7",
                    strokeWidth: '97%',
                    shadow: {
                        enabled: true,
                        top: 2,
                        left: 0,
                        color: '#999',
                        opacity: 1,
                        blur: 2
                    }
                },
                dataLabels: {
                    name: {
                        show: true,
                        fontSize: '16px'
                    },
                    value: {
                        offsetY: 4,
                        fontSize: '16px'
                    }
                },
            }
        },
        labels: [t('data-lang-lbl-epbalance')], // Etiqueta del valor
        colors: ['#406A9C'], // Color del gráfico radial
      }
    };

    this.fakeData = {item: {
      nroEp: 0,
      nroEpAnterior: 0,
      periodoId: 0,
      moneda: 0,
      montoAcum: 0,
      montoSaldo: 0,
      montoPago: 0,
      goalPercent: 0
    }}
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false
  };

  renderContent(data) {

    return  <Row className='px-3 h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
              <Col xl={5}>
                <ReactApexChart options={this.state.options} series={this.state.series} type="radialBar" height="76%" />
              </Col>
              <Col>
                <Row>
                  <Col className='px-0'>
                    <div className='border-top border-bottom border-end' style={{ backgroundColor: "#efefef", borderLeft: 10, borderLeftStyle: "solid", borderLeftColor: "#84B681"}}>
                      <Row className='px-1'>
                        <Col>
                          <Row>
                            <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "32px"}}>
                              {
                                data !== null && data.item !== null &&
                                data.item.item_cobertura ?
                                  data.item.item_cobertura.displayValue : '--'
                              }
                            </Col>
                            <Col xl={12} className='text-center'>{t('data-lang-lbl-coverageupper')}</Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col xl={12} className='text-center font-weight-bold' style={{fontSize: "32px"}}>
                              {
                                data !== null && data.item !== null &&
                                data.item.item_cobertura ?
                                  data.item.item_cobertura.valueGoal : '--'
                              }
                            </Col>
                            <Col xl={12} className='text-center'>{t('data-lang-lbl-goalupper')}</Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row className='mt-1 border'>
                  <Col>
                    <Row className='pb-1'>
                      <Col className='border-top border-bottom border-end' style={{backgroundColor: "#efefef"}}>
                        <Row>
                          <Col className='px-1' xl={8}>{t('data-lang-lbl-epnumber')}</Col>
                          <Col className='px-1 font-weight-bold text-start'>{data !== null && data.item !== null ? data.item.nroEp : '--'}</Col>
                        </Row>
                      </Col>
                      <Col className='border-top border-bottom'>
                        <Row>
                          <Col className='px-1' xl={8}>{t('data-lang-lbl-lastepnumber')}</Col>
                          <Col className='px-1 font-weight-bold text-start'>{data !== null && data.item !== null ? data.item.nroEpAnterior : '--'}</Col>
                        </Row>
                      </Col>
                    </Row>
                    
                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-epmonth')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null ? data.item.periodoId : '--'}</Col>
                    </Row>
                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-currency')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null ? data.item.moneda : '--'}</Col>
                    </Row>

                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-accumulatedamount')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null && data.item.montoAcum !== null ? parseFloat(data.item.montoAcum.toFixed(2)).toLocaleString(i18next.language) : '--'}</Col>
                    </Row>
                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-balanceamount')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null && data.item.montoSaldo !== null ? parseFloat(data.item.montoSaldo.toFixed(2)).toLocaleString(i18next.language) : '--'}</Col>
                    </Row>
                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-paymentamount')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null && data.item.montoPago !== null ? parseFloat(data.item.montoPago.toFixed(2)).toLocaleString(i18next.language) : '--'}</Col>
                    </Row>
                    <Row className='border-top border-bottom'>
                      <Col className='px-1'>{t('data-lang-lbl-goalpercent')}</Col>
                      <Col className='px-1 font-weight-bold text-end'>{data !== null && data.item !== null && data.item.goalPercent !== null  ? parseFloat(data.item.goalPercent.toFixed(2)).toLocaleString(i18next.language) : '--'}</Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
  }

  render() {
    return (
      <>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100'>
          {
            !this.props.inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="d-flex justify-content-between">
                <b>{ (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-lastep')}</b>
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                    inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                    inputParam_Container={this.props.inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='px-1 py-1 h-100'>
            {this.renderContent(this.props.inputParam_ComponentContent)}
          </Card.Body>
        </Card>
      }
      {this.props.inputParam_UseFake && this.renderContent(this.fakeData)}
      </>
    );
  }
}

export default CONTRACT_LAST_EDP;